import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  HeartIcon,
  UserGroupIcon,
  ClockIcon,
  LogOutIcon,
} from "../../components/Icon/Icon";
import BASE_URL from "../../configs/api";

const UserLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const [userData, setUserData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    gender: "",
    avatar: "",
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    axios
      .get(`${BASE_URL}/api/auth/profile/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setUserData({
          email: data.email || "",
          first_name: data.first_name || "",
          last_name: data.last_name || "",
          gender: data.gender || "undefined",
          avatar: data.anh_dai_dien_url || data.anh_dai_dien,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/");
  };

  return (
    <div className=" px-3 py-6">
      <div className="lg:container lg:mx-auto px-1 md:px-2 lg:px-1">
        <div className="flex flex-col xl:flex-row gap-6 lg:gap-10">
          {/* Sidebar */}
          <div className="bg-[#25272f] w-full xl:w-80 min-w-0 rounded-lg shadow-lg self-start">
            <div className="p-2 lg:p-8">
              <h2 className="text-center lg:text-start text-white font-semibold text-lg lg:text-xl mb-6">
                Quản lý tài khoản
              </h2>

              <ul className="flex flex-row justify-center lg:justify-start lg:flex-col gap-2 lg:gap-5 text-white w-full">
                <li className="w-full">
                  <button
                    onClick={() => navigate("/user/favorites")}
                    className={`w-full flex flex-col lg:flex-row items-center justify-center lg:justify-start gap-3 px-4 py-3 transition-all duration-200 border-b-2 ${
                      isActive("/user/favorites")
                        ? "border-orange-300 text-white"
                        : "border-transparent hover:border-orange-300 hover:text-orange-300 text-gray-300"
                    }`}
                  >
                    <HeartIcon className="w-4 h-4" />
                    <span className="text-sm lg:text-base">Yêu thích</span>
                  </button>
                </li>

                <li className="w-full">
                  <button
                    onClick={() => navigate("/user/continue-watching")}
                    className={`w-full flex flex-col lg:flex-row items-center justify-center lg:justify-start gap-3 px-4 py-3 transition-all duration-200 border-b-2 ${
                      isActive("/user/continue-watching")
                        ? "border-orange-300 text-white"
                        : "border-transparent hover:border-orange-300 hover:text-orange-300 text-gray-300"
                    }`}
                  >
                    <ClockIcon className="w-4 h-4" />
                    <span className="text-sm lg:text-base">Lịch sử xem</span>
                  </button>
                </li>

                {/* <li className="w-full">
                  <button
                    onClick={() => navigate("/user/announce/")}
                    className={`w-full flex flex-col lg:flex-row items-center justify-center lg:justify-start gap-3 px-4 py-3 transition-all duration-200 border-b-2 ${
                      isActive("/user/announce/")
                        ? "border-[#fa702c] text-white"
                        : "border-transparent hover:border-[#fa702c] hover:text-[#fa702c] text-gray-300"
                    }`}
                  >
                    <ClockIcon className="w-4 h-4" />
                    <span className="text-sm lg:text-base">Thông báo</span>
                  </button>
                </li> */}

                <li className="w-full">
                  <button
                    onClick={() => navigate("/user/profile")}
                    className={`w-full flex flex-col lg:flex-row items-center justify-center lg:justify-start gap-3 px-4 py-3 transition-all duration-200 border-b-2 ${
                      isActive("/user/profile")
                        ? "border-orange-300 text-white"
                        : "border-transparent hover:border-orange-300 hover:text-orange-300 text-gray-300"
                    }`}
                  >
                    <UserGroupIcon className="w-4 h-4" />
                    <span className="text-sm lg:text-base">Tài khoản</span>
                  </button>
                </li>
              </ul>
            </div>

            {/* User Profile Section */}
            <div className="hidden xl:block border-t border-white/10 p-6 lg:p-8">
              {isLoading ? (
                <div className="flex flex-col items-center space-y-3">
                  <Skeleton circle height={64} width={64} />
                  <Skeleton width={100} height={16} />
                  <Skeleton width={140} height={14} />
                  <Skeleton width={80} height={32} className="mt-2" />
                </div>
              ) : (
                <div className="flex flex-col items-center text-center space-y-3">
                  <img
                    className="w-16 h-16 rounded-full border-2 border-white object-cover shadow-md"
                    src={userData.avatar}
                    alt="Avatar"
                  />
                  <div>
                    <h3 className="text-white font-semibold text-base">
                      {userData.first_name} {userData.last_name}
                    </h3>
                    <p className="text-gray-300 text-sm mt-1 break-all">
                      {userData.email}
                    </p>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="flex items-center gap-2 px-4 py-2 mt-4 bg-red-600/20 hover:bg-red-600/30 border border-red-500/50 rounded-lg text-red-400 hover:text-red-300 transition-all duration-200"
                  >
                    <LogOutIcon className="w-4 h-4" />
                    <span className="text-sm font-medium">Đăng xuất</span>
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1 px-1 lg:px-2">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLayout;
